import { shallowRef as t, onUnmounted as n } from "vue";
function s(e) {
  let o = t(e.getSnapshot());
  return n(e.subscribe(() => {
    o.value = e.getSnapshot();
  })), o;
}
export {
  s as useStore
};
